export enum ReferrerAccountStatus {
  Active = "active",
  Paused = "paused",
  Terminated = "terminated",
}
